import {FirestoreTimestamp} from '../_other/firestore/firestoreTimestampSchema';
import {TradeDb} from './tradeDbSchema';
import {TradeWrite} from './tradeWriteSchema';

export function mapTradeWriteToDb(tradeWrite: TradeWrite, createdAt: FirestoreTimestamp): TradeDb {
  const {message, ...rest} = tradeWrite;

  return {
    ...rest,
    messages: message ? [message] : [],
    createdAt,
  };
}
